import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { Employee } from 'src/app/model/Employee';
import { EmployeeDependents } from 'src/app/model/EmployeeDependents';
import moment from 'moment';
import { skills } from 'src/app/constants/skills';
import { EmployeeService } from 'src/app/services/employee.service';
import { Moment } from 'moment';
import { LoaderService } from 'src/app/services/loader.service';
import { User } from 'src/app/model/User';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-addemployee',
  templateUrl: './addemployee.component.html',
  styleUrls: ['./addemployee.component.css'],
  providers: [DatePipe],
})
export class AddemployeeComponent implements OnInit {
  public employeeId: number;
  public successFlag: Boolean = false;
  showMarriageSectionFlag = false;
  disablePermanentSectionFlag = true;
  uploadDocuments = false;
  public step = 0;
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  dob: Date;
  empDependants: EmployeeDependents[] = [];
  savedEmpDependants: EmployeeDependents[] = [];
  employee: Employee = new Employee();
  empId = '';
  skillsetList: string[] = skills;
  skillset: UntypedFormControl = new UntypedFormControl();
  fileList = 'employee';
  retrievedImage: any;
  base64Data: any;
  filterEmpName: string;
  empName: any = undefined;
  martialStatusChecked: boolean = false;
  loading$: any;
  onboardingStatus: any;
  employmentType: any;
  isFixedTerm: boolean = false;
  user: User;
  imageLoading = false;

  @ViewChild('marriageCheckbox') marriageCheckbox: ElementRef;

  constructor(
    private fb: UntypedFormBuilder,
    private employeeService: EmployeeService,
    private loader: LoaderService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit(): void {
    this.loading$ = this.loader.loading$;
    const employmentTypeControl = this.empCreationForm.get(
      'empBasicInfo.employmentType',
    );
    employmentTypeControl?.valueChanges.subscribe((type) => {
      this.onEmploymentTypeChange(type);
    });

    const contractTypeControl = this.empCreationForm.get(
      'empBasicInfo.contractType',
    );
    contractTypeControl?.valueChanges.subscribe((type) => {
      this.updateContractFields(type);
    });
  }

  setStep(index: number) {
    this.step = index;
  }

  employeeDetailsValidation() {
    console.log(
      ' validation flag value ... ' +
        this.empCreationForm.get('empBasicInfo')?.valid,
    );
    if (this.empCreationForm.get('empBasicInfo')?.valid) {
      console.log(
        ' validation flag value ... ' +
          this.empCreationForm.get('empBasicInfo')?.valid,
      );
      this.step++;
    }
  }

  addressDetailsValidation() {
    if (this.empCreationForm.get('employeeAddress')?.valid) {
      console.log(
        ' validation flag value ... ' +
          this.empCreationForm.get('empBasicInfo')?.valid,
      );
      this.step++;
    }
  }

  empNameSelected(emp: any) {
    this.empName = emp;
  }

  onNationalitySelected(country: any) {
    if (country == 'Belgium') {
      this.disablePermanentSectionFlag = false;
    } else {
      this.disablePermanentSectionFlag = true;
    }
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  dependantSubmitted(dependant: EmployeeDependents[]) {
    this.empDependants = dependant;
  }

  enableDependentSection(status: any) {
    console.log(status);
    this.showMarriageSectionFlag = status;
  }

  onEmploymentTypeChange(type: string) {
    const contractTypeControl = this.empCreationForm.get(
      'empBasicInfo.contractType',
    );

    if (type === 'Employee') {
      contractTypeControl?.setValue('OE', { emitEvent: false });
      this.isFixedTerm = false;
      this.updateContractFields('OE');
    } else if (type === 'Contractor' || type === 'FreeLancer') {
      contractTypeControl?.setValue('FT', { emitEvent: false });
      this.isFixedTerm = true;
      this.updateContractFields('FT');
    } else {
      this.isFixedTerm = contractTypeControl?.value === 'FT';
      this.updateContractFields(contractTypeControl?.value);
    }
  }

  updateContractFields(type: string) {
    const contractStartControl = this.empCreationForm.get(
      'empBasicInfo.contractStartDate',
    );
    const contractEndControl = this.empCreationForm.get(
      'empBasicInfo.contractEndDate',
    );
    const fixed = type === 'FT';

    this.isFixedTerm = fixed;
    if (fixed) {
      contractStartControl?.setValidators([Validators.required]);
      contractEndControl?.setValidators([Validators.required]);
    } else {
      contractStartControl?.clearValidators();
      contractEndControl?.clearValidators();
      contractStartControl?.setValue(null);
      contractEndControl?.setValue(null);
    }

    contractStartControl?.updateValueAndValidity();
    contractEndControl?.updateValueAndValidity();
  }

  onSubmit() {
    //new Date(this.moment(date).utcOffset('+0000').format('YYYY-MM-DD HH:MM'))
    this.user = JSON.parse(localStorage.getItem('userDetails') || '{}') as User;
    console.log(this.empCreationForm.value);
    this.employee = Object.assign({}, this.empCreationForm.value);
    this.employee.employeeDependents = this.empDependants;
    //let dsd = this.empCreationForm.get('empBasicInfo.dob');
    //this.employee.empBasicInfo.dob = dsd?.value;
    this.employee.updatedBy = this.user.empId;
    //this.employee.empBasicInfo.dob =  this.datePipe.transform(this.empCreationForm.value.empBasicInfo.dob, 'dd-MM-yyyy');
    this.employee.empBasicInfo.dob = new Date(
      moment(this.empCreationForm.value.empBasicInfo.dob)
        .utcOffset('+2000')
        .format('YYYY-MM-DD'),
    );
    this.employee.empBasicInfo.onboardingDate = new Date(
      moment(this.empCreationForm.value.empBasicInfo.onboardingDate)
        .utcOffset('+2000')
        .format('YYYY-MM-DD'),
    );
    if (this.empCreationForm.value.empBasicInfo.rpExpiryDate != null) {
      this.employee.empBasicInfo.rpExpiryDate = new Date(
        moment(this.empCreationForm.value.empBasicInfo.rpExpiryDate)
          .utcOffset('+2000')
          .format('YYYY-MM-DD'),
      );
    }
    if (this.empCreationForm.value.empBasicInfo.empLastDate != null) {
      this.employee.empBasicInfo.empLastDate = new Date(
        moment(this.empCreationForm.value.empBasicInfo.empLastDate)
          .utcOffset('+2000')
          .format('YYYY-MM-DD'),
      );
    }

    const empJson = JSON.stringify(this.employee);
    console.log('empJson ' + empJson);

    this.employeeService.createEmployee(this.employee).subscribe((data) => {
      console.log('data ==========> ' + data);
      this.employeeId = data.employeeId;
      this.empCreationForm.reset();
    });
    this.successFlag = true;
    console.log('employeeId...' + this.employeeId);
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  public handleMissingImage(event: Event) {
    (event.target as HTMLImageElement).style.display = 'none';
  }

  loadEmployeeImage(empName: string) {
    console.log('loadEmployeeImage...' + empName);
    this.imageLoading = true;
    this.retrievedImage = null;
    this.employeeService.getEmployeeImage(empName).subscribe({
      next: (imgUrl: string) => {
        this.retrievedImage = imgUrl;
        // imageLoading will be set to false in (load) event in HTML
      },
      error: () => {
        this.imageLoading = false;
        this.retrievedImage = null;
      },
    });
  }

  onImageError() {
    this.imageLoading = false;
    this.retrievedImage = 'assets/images/default.jpg'; // fallback image
  }

  searchEmployees() {
    this.successFlag = false;
    if (this.empName != '') {
      const emparr = this.empName.split('-');
      this.empCreationForm.reset();
      this.savedEmpDependants = [];
      this.employeeService.fetchEmployeeById(emparr[0]).subscribe((data) => {
        console.log('data ==========> ' + data);
        this.employee = data;
        this.empCreationForm.patchValue({
          empBasicInfo: this.employee.empBasicInfo,
          employeeAddress: this.employee.employeeAddress,
          skillset: this.employee.skillset,
        });
        this.savedEmpDependants = this.employee.employeeDependents;
        this.empId = this.employee.empBasicInfo.empId;
        if (
          this.savedEmpDependants != null &&
          this.savedEmpDependants.length > 0
        ) {
          this.showMarriageSectionFlag = true;
          this.martialStatusChecked = true;
        }
        this.uploadDocuments = true;

        if (this.employee.employeeAddress.nationality == 'Belgium') {
          this.disablePermanentSectionFlag = false;
        } else {
          this.disablePermanentSectionFlag = true;
        }

        // this.base64Data = this.employee.empImage;
        //  this.retrievedImage = 'data:image/jpeg;base64,' + this.base64Data;

        this.empCreationForm.patchValue({
          empBasicInfo: {
            dob: moment(this.employee.empBasicInfo.dob, 'DD/MM/YYYYT00:00:00'),
            onboardingDate: moment(
              this.employee.empBasicInfo.onboardingDate,
              'DD/MM/YYYYT00:00:00',
            ),
            rpExpiryDate: moment(
              this.employee.empBasicInfo.rpExpiryDate,
              'DD/MM/YYYYT00:00:00',
            ),
            empLastDate: moment(
              this.employee.empBasicInfo.empLastDate,
              'DD/MM/YYYYT00:00:00',
            ),
            contractStartDate: moment(
              this.employee.empBasicInfo.contractStartDate,
              'DD/MM/YYYYT00:00:00',
            ),
            contractEndDate: moment(
              this.employee.empBasicInfo.contractEndDate,
              'DD/MM/YYYYT00:00:00',
            ),
          },
        });
      });
      this.loadEmployeeImage(emparr[0]);
    }
  }

  dobFilter = new Date();

  dateOfJoiningFilter = (m: Moment | null): boolean => {
    const day = (m || moment()).day();
    return day !== 0 && day !== 6;
  };

  empCreationForm = this.fb.group({
    empBasicInfo: this.fb.group({
      empId: [],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      sex: ['', Validators.required],
      dob: ['', Validators.required],
      ssn: [],
      rpExpiryDate: [],
      email: ['', Validators.required],
      mobile: ['', Validators.required],
      landline: [],
      passportId: [],
      onboardingStatus: ['', Validators.required],
      onboardingDate: ['', Validators.required],
      ibannumber: [],
      bicCode: [],
      martialStatus: [''],
      emergencyContactPerson: [],
      emergencyContactNumber: [],
      entity: [],
      empLastDate: [],
      hrSpoc: [],
      designation: [],
      nishEmail: [],
      employmentType: ['', Validators.required],
      contractType: ['', Validators.required],
      contractStartDate: [],
      contractEndDate: [],
    }),
    employeeAddress: this.fb.group({
      addressId: [],
      currentAddress1: ['', Validators.required],
      currentAddress2: [],
      currentCity: ['', Validators.required],
      currentState: [],
      currentCountry: ['', Validators.required],
      currentPincode: ['', Validators.required],
      nationality: [],
      permanentAddress1: [],
      permanentAddress2: [],
      permanentAddcity: [],
      permanentAddstate: [],
      permanentAddcountry: [],
      permanentAddpincode: [],
    }),
    skillset: this.fb.group({
      skillset: ['', Validators.required],
    }),
    updatedBy: [],
  });
}
